(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flosstube-gallery"] && !Shopify.designMode) return;
  try {
    
  class FlosstubeGallery extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
      this.filtersContainer = this.querySelector('[data-filters]');
      this.loadMoreButton = this.querySelector('[data-load-more]');
      this.batchSize = 12;
      this.visibleCount = this.batchSize;
      this.activeFilter = 'all';

      this.buildFilters();
      this.updateCards();

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', () => {
          this.visibleCount += this.batchSize;
          this.updateCards();
        });
      }
    }

    buildFilters() {
      if (!this.filtersContainer) return;

      const categories = [
        ...new Set(
          this.cards
            .map((card) => card.dataset.category.trim())
            .filter(Boolean)
        )
      ];

      categories.forEach((category) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'flosstube-filter';
        button.dataset.filter = category;
        button.textContent = category;

        button.addEventListener('click', () => {
          this.setFilter(category, button);
        });

        this.filtersContainer.appendChild(button);
      });

      const allButton = this.filtersContainer.querySelector('[data-filter="all"]');

      if (allButton) {
        allButton.addEventListener('click', () => {
          this.setFilter('all', allButton);
        });
      }
    }

    setFilter(category, button) {
      this.activeFilter = category;
      this.visibleCount = this.batchSize;

      this.querySelectorAll('.flosstube-filter').forEach((filter) => {
        filter.classList.remove('is-active');
      });

      button.classList.add('is-active');
      this.updateCards();
    }

    updateCards() {
      const matchingCards = this.cards.filter((card) => {
        return (
          this.activeFilter === 'all' ||
          card.dataset.category === this.activeFilter
        );
      });

      this.cards.forEach((card) => {
        card.hidden = true;
      });

      matchingCards.slice(0, this.visibleCount).forEach((card) => {
        card.hidden = false;
      });

      if (this.loadMoreButton) {
        this.loadMoreButton.hidden =
          matchingCards.length <= this.visibleCount;
      }
    }
  }

  if (!customElements.get('flosstube-gallery')) {
    customElements.define('flosstube-gallery', FlosstubeGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
